/**
 * PCS Subscription Cards — Collection Page
 * Handles: variant switching, Einzel/Abo toggle, frequency dropdown, Cart API
 * No dependency on Shopify Subscriptions App widget.
 */
(function () {
  'use strict';

  function initCard(card) {
    if (card.dataset.pcsInit) return;
    card.dataset.pcsInit = '1';

    var variants = JSON.parse(card.dataset.variants || '[]');
    var plans = JSON.parse(card.dataset.sellingPlans || '[]');

    // State
    var state = {
      variantIndex: 0,
      mode: 'otp', // 'abo' | 'otp'
      planId: plans.length > 0 ? plans[0].id : null
    };

    // Elements
    var pills = card.querySelectorAll('.pcc__pill');
    var otpRow = card.querySelector('[data-option="otp"]');
    var aboRow = card.querySelector('[data-option="abo"]');
    var otpPriceEl = card.querySelector('[data-otp-price]');
    var aboPriceEl = card.querySelector('[data-abo-price]');
    var ctaBtn = card.querySelector('[data-pcs-atc]');
    var ctaText = card.querySelector('[data-cta-text]');
    var freqSelect = card.querySelector('[data-frequency-select]');

    if (!otpRow || !aboRow || !ctaBtn || variants.length === 0) return;

    // --- Simplify frequency labels in dropdown ---
    if (freqSelect) {
      Array.from(freqSelect.options).forEach(function (opt) {
        opt.textContent = simplifyFrequency(opt.textContent.trim());
      });
    }
    // Simplify static frequency text
    var freqText = card.querySelector('.pcc__frequency-text');
    if (freqText) {
      freqText.textContent = simplifyFrequency(freqText.textContent.trim());
    }

    // --- Disable pills for unavailable variants ---
    // Note: This assumes single-option products (pill index = variant index).
    // Multi-option products would need a variant lookup by option value.
    pills.forEach(function (pill, idx) {
      if (variants[idx] && !variants[idx].available) {
        pill.disabled = true;
      }
    });

    // --- Variant pill switching ---
    pills.forEach(function (pill, idx) {
      pill.addEventListener('click', function () {
        if (pill.disabled) return;
        pills.forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        state.variantIndex = idx;
        updatePrices();
        updateCtaState();
      });
    });

    // --- Option row click (Einzel/Abo) ---
    var freqEl = card.querySelector('.pcc__frequency');

    otpRow.addEventListener('click', function () {
      state.mode = 'otp';
      updateActiveRow();
      updateCtaStyle();
      if (freqEl) freqEl.classList.remove('is-visible');
    });

    aboRow.addEventListener('click', function (e) {
      // Don't toggle mode when clicking the frequency dropdown
      if (e.target.closest('[data-frequency-select]')) return;
      // Don't toggle when row is disabled (= product has no Abo plan)
      if (aboRow.classList.contains('pcc__option-row--disabled')) return;
      state.mode = 'abo';
      updateActiveRow();
      updateCtaStyle();
      if (freqEl) freqEl.classList.add('is-visible');
    });

    // --- Frequency dropdown ---
    if (freqSelect) {
      freqSelect.addEventListener('change', function () {
        state.planId = parseInt(this.value, 10);
        updatePrices();
      });
    }

    // --- Add to Cart ---
    ctaBtn.addEventListener('click', function () {
      if (ctaBtn.disabled) return;

      var variant = variants[state.variantIndex];
      if (!variant || !variant.available) return;

      // Use items-array + sections so Shopify returns updated section HTML
      // (cart-icon-bubble + cart-drawer) that we can swap into the DOM —
      // same pattern Dawn's product-form.js uses. This fixes the bug where
      // an empty initial cart has no .cart-count-bubble element to update.
      var item = { id: variant.id, quantity: 1 };
      if (state.mode === 'abo' && state.planId) {
        item.selling_plan = state.planId;
      }

      var sectionsToUpdate = [];
      if (document.getElementById('cart-icon-bubble')) sectionsToUpdate.push('cart-icon-bubble');
      if (document.querySelector('cart-drawer')) sectionsToUpdate.push('cart-drawer');
      if (document.getElementById('cart-live-region-text')) sectionsToUpdate.push('cart-live-region-text');

      var body = { items: [item] };
      if (sectionsToUpdate.length > 0) {
        body.sections = sectionsToUpdate;
        body.sections_url = window.location.pathname;
      }

      ctaBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/javascript'
        },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart error');
          return res.json();
        })
        .then(function (data) {
          showCtaFeedback('success', '✓ Hinzugefügt', 1500);

          // Swap in updated section HTML — handles empty-cart-initial case
          if (data && data.sections) {
            updateSectionsFromResponse(data.sections);
          } else {
            updateCartCount();
          }

          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        })
        .catch(function () {
          showCtaFeedback('error', 'Fehler — erneut versuchen', 2000);
        });
    });

    function updateSectionsFromResponse(sections) {
      Object.keys(sections).forEach(function (sectionId) {
        var html = sections[sectionId];
        if (!html) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        if (sectionId === 'cart-icon-bubble') {
          var src = doc.getElementById('cart-icon-bubble') || doc.querySelector('[id*="cart-icon"]');
          var dst = document.getElementById('cart-icon-bubble');
          if (src && dst) dst.innerHTML = src.innerHTML;
        } else if (sectionId === 'cart-drawer') {
          var srcDrawer = doc.querySelector('cart-drawer');
          var dstDrawer = document.querySelector('cart-drawer');
          if (srcDrawer && dstDrawer) dstDrawer.innerHTML = srcDrawer.innerHTML;
        } else if (sectionId === 'cart-live-region-text') {
          var srcLive = doc.getElementById('cart-live-region-text');
          var dstLive = document.getElementById('cart-live-region-text');
          if (srcLive && dstLive) dstLive.innerHTML = srcLive.innerHTML;
        }
      });
    }

    // --- Helpers ---

    function updatePrices() {
      var variant = variants[state.variantIndex];
      if (!variant) return;

      otpPriceEl.textContent = formatMoney(variant.price);

      // Find the abo price for current plan
      var aboPrice = null;
      for (var i = 0; i < variant.abo_prices.length; i++) {
        if (variant.abo_prices[i].plan_id === state.planId) {
          aboPrice = variant.abo_prices[i].price;
          break;
        }
      }
      // If no matching plan found, use the first one
      if (aboPrice === null && variant.abo_prices.length > 0) {
        aboPrice = variant.abo_prices[0].price;
      }
      if (aboPrice === null) aboPrice = variant.price;
      aboPriceEl.textContent = formatMoney(aboPrice);
    }

    function updateActiveRow() {
      otpRow.classList.toggle('is-active', state.mode === 'otp');
      aboRow.classList.toggle('is-active', state.mode === 'abo');
    }

    function updateCtaText() {
      if (!ctaText) return;
      ctaText.textContent = state.mode === 'abo' ? 'Abo starten & 10% sparen' : 'in den Warenkorb';
    }

    function updateCtaStyle() {
      ctaBtn.classList.toggle('pcc__cta--abo', state.mode === 'abo');
      updateCtaText();
      // Toggle delivery note
      var deliveryNote = card.querySelector('.pcc__delivery-note');
      if (deliveryNote) deliveryNote.classList.toggle('is-visible', state.mode === 'abo');
    }

    function updateCtaState() {
      var variant = variants[state.variantIndex];
      if (!variant || !variant.available) {
        ctaBtn.disabled = true;
        ctaText.textContent = 'Ausverkauft';
      } else {
        ctaBtn.disabled = false;
        updateCtaText();
      }
    }

    function showCtaFeedback(type, message, duration) {
      ctaText.textContent = message;
      ctaBtn.classList.add('pcc__cta--' + type);
      setTimeout(function () {
        ctaBtn.classList.remove('pcc__cta--' + type);
        updateCtaText();
        ctaBtn.disabled = false;
      }, duration);
    }

    function updateCartCount() {
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var countEls = document.querySelectorAll('.cart-count-bubble span[aria-hidden]');
          countEls.forEach(function (el) { el.textContent = cart.item_count; });
          var bubbles = document.querySelectorAll('.cart-count-bubble');
          bubbles.forEach(function (b) {
            if (cart.item_count > 0) b.removeAttribute('hidden');
          });
        })
        .catch(function () { /* silent */ });
    }

    function simplifyFrequency(text) {
      var m;
      if ((m = text.match(/(\d+)\s*Wochen?/i))) return 'Alle ' + (parseInt(m[1], 10) * 7) + ' Tage';
      if (/Jede\s+Woche/i.test(text)) return 'Alle 7 Tage';
      if ((m = text.match(/(\d+)\s*Tage?/i))) return 'Alle ' + m[1] + ' Tage';
      if (/Jeden\s+Tag/i.test(text)) return 'Jeden Tag';
      if ((m = text.match(/(\d+)\s*Monate?/i))) return 'Alle ' + m[1] + ' Monate';
      if (/Jeden\s+Monat/i.test(text)) return 'Jeden Monat';
      // English fallbacks
      if ((m = text.match(/every\s+(\d+)\s+weeks?/i))) return 'Alle ' + (parseInt(m[1], 10) * 7) + ' Tage';
      if (/every\s+week/i.test(text)) return 'Alle 7 Tage';
      if ((m = text.match(/every\s+(\d+)\s+days?/i))) return 'Alle ' + m[1] + ' Tage';
      if (/every\s+day/i.test(text)) return 'Jeden Tag';
      // Strip discount suffix like ", 10 % Rabatt"
      return text.replace(/,\s*\d+\s*%\s*Rabatt/i, '').trim();
    }

    function formatMoney(cents) {
      // Match Shopify's German locale format: "12,34€"
      // Uses the store's money_format from Liquid (injected on window)
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents, window.theme_money_format || '{{amount_with_comma_separator}}€');
      }
      return (cents / 100).toFixed(2).replace('.', ',') + '€';
    }
  }

  // --- Init all cards ---
  function initAll() {
    document.querySelectorAll('[data-pcs-card]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init after sort/filter (Dawn replaces product grid via AJAX)
  var gridObserver = new MutationObserver(function () {
    initAll();
  });
  var target = document.getElementById('ProductGridContainer') || document.getElementById('product-grid');
  if (target) {
    gridObserver.observe(target, { childList: true, subtree: true });
  }
})();
